import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/rates',
    name: 'Rates',
    component: () => import('../views/Rates')
  },
  {
    path: '/buy/sell',
    name: 'Buy/Sell',
    component: () => import('../views/BuySell')
  },
  {
    path: '/assets',
    name: 'Assets',
    component: () => import('../views/Assets')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products')
  },
  {
    path: '/policyAcknowledgement',
    name: 'Policy Acknowledgement',
    component: () => import('@/views/PolicyAcknowledgement'),
    props: true
  },
  {
    path: '/policy',
    name: 'Policy',
    component: () => import('@/views/Policy')
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: () => import('../views/Tasks')
  },
  {
    path: '/tasks/:uuid',
    name: 'Task',
    component: () => import('../components/service/task'),
    props: true
  },
  {
    path: '/service/request/new',
    name: 'New Service Request',
    component: () => import('../views/NewServiceRequest')
  },
  {
    path: '/reportsCards',
    name: 'ReportsCards',
    component: () => import('../views/ReportsCards')
  },
  {
    path: '/reportsCreditDebit',
    name: 'ReportsCreditDebit',
    component: () => import('../views/ReportsCreditDebit')
  },
  {
    path: '/reportsWireCheck',
    name: 'ReportsWireCheck',
    component: () => import('../views/ReportsWireCheck')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login')
  },
  {
    path: '/proxy',
    name: 'Proxy',
    component: () => import('../views/Proxy')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/Settings')
  },
  {
    path: '/access',
    name: 'RosterAccess',
    component: () => import('../views/RosterAccess')
  },
  {
    path: '/roles',
    name: 'RosterRoles',
    component: () => import('../views/RosterRoles')
  },
  {
    path: '/IRAAccounts',
    name: 'IRAAccounts',
    component: () => import('../views/IRAAccounts')
  },
  {
    path: '/franchises',
    name: 'Franchises',
    component: () => import('../views/Franchises')
  },
  {
    path: '/merchants',
    name: 'Merchants',
    component: () => import('../views/Merchants')
  },
  {
    path: '/adjustment',
    name: 'Adjustment',
    component: () => import('../views/Adjustment')
  },
  {
    path: '/pendingTransactions',
    name: 'PendingTransactions',
    component: () => import('../components/reports/PendingTransactions')
  },
  {
    path: '/trust',
    name: 'Trust',
    component: () => import('../components/reports/Trust')
  },
  {
    path: '/lease',
    name: 'Lease',
    component: () => import('../components/reports/Lease')
  },
  {
    path: '/holdingsReport',
    name: 'HoldingsReport',
    component: () => import('../components/reports/Holdings')
  },
  {
    path: '/memberTotals/:start/:end',
    name: 'memberTotals',
    component: () => import('../components/reports/MemberTransactionsPrintTotals'),
    props: true
  },
  {
    path: '/memberTransactionDetail/:journalNum',
    name: 'memberDetail',
    component: () => import('../components/reports/MemberTransactionsPrintDetail'),
    props: true
  },
  {
    // Catch-all route for authenticated users - redirect to tasks
    path: '*',
    beforeEnter: (to, from, next) => {
      // This will only be reached if no other route matched
      // The main router guard will handle authentication, so if we get here
      // the user is authenticated but accessing a non-existent route
      next('/tasks');
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// This reroutes users to the login view when logged out.
router.beforeEach(async (to, from, next) => {
  // Skip auth check if already on login page
  if (to.name === 'Login') {
    return next();
  }

  if (router.app.$data === undefined) {
    try {
      let res = await router.app.$axios.get('/admin/user');
      router.app.$emit('logged-in', res.data);
    } catch (e) {
      console.log(e);
      // User is not authenticated, redirect to login with intended destination

      return next({
        path: '/login',
        query: { 
          redirect: to.fullPath
        }
      })
    }
  }
  return next();
});

export default router;
